const elementVisibility = function () {
    return {
        show: function ( toggleId:string ) {
            const ele: HTMLElement | null = document.getElementById(toggleId);
            if (ele) ele.style.display = 'block';
        },
        hide: function (toggleId: string) {
            const ele: HTMLElement | null = document.getElementById(toggleId);
            if (ele) ele.style.display = 'none';
        }
    }
}();

export default elementVisibility;